import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalDay: 0,
    percentTotal: 0,
    title: ''
};

export const useNotEscaletedLinesTodayStore = create((set) => ({

    ...initialState,

    setNotEscaletedLinesToday: ({
        data,
        total,
        totalDay,
        percentTotal,
        title
    }) => {
        set({
            data,
            total,
            totalDay,
            percentTotal,
            title
        });
    },

    clearNotEscaletedLinesToday: () => {
        set(initialState);
    }

}));